import number from './number';
import pluralize from './pluralize';

export default {
    number,
    pluralize
};
